import { useState } from 'react'

import { findDocumentMatches } from '../../util/redaction/documentSearch'

// Manage in-document search state and page navigation for the redaction editor.
export default function useDocumentSearch({ pages, pageNavigation }) {
  const [isOpen, setIsOpen] = useState(false)
  const [query, setQuery] = useState('')
  const [isSearching, setIsSearching] = useState(false)
  const [hasSearched, setHasSearched] = useState(false)
  const [results, setResults] = useState([])
  const [activeIndex, setActiveIndex] = useState(0)

  function clearResults() {
    setHasSearched(false)
    setResults([])
    setActiveIndex(0)
  }

  function open() {
    setQuery('')
    clearResults()
    setIsOpen(true)
  }

  function close() {
    setIsOpen(false)
    setQuery('')
    clearResults()
  }

  function updateQuery(value) {
    setQuery(value)
    clearResults()
  }

  function showResult(index, nextResults = results) {
    if (!nextResults.length) return

    const nextIndex = (index + nextResults.length) % nextResults.length
    setActiveIndex(nextIndex)
    pageNavigation.goToPage(nextResults[nextIndex].page + 1)
  }

  async function search(event) {
    event?.preventDefault?.()
    if (!query.trim() || isSearching) return

    setIsSearching(true)
    try {
      const nextResults = await findDocumentMatches(pages, query)
      setResults(nextResults)
      setHasSearched(true)
      setActiveIndex(0)
      if (nextResults.length) pageNavigation.goToPage(nextResults[0].page + 1)
    } finally {
      setIsSearching(false)
    }
  }

  return {
    isOpen,
    query,
    isSearching,
    hasSearched,
    results,
    activeIndex,
    open,
    close,
    updateQuery,
    search,
    showPrevious: () => showResult(activeIndex - 1),
    showNext: () => showResult(activeIndex + 1)
  }
}
